import { type SearchRequest } from '@searchkit/api';
import { merge } from 'merge-anything';

import { type SearchRuntimeSortingConfig } from '~/search-domain/types';
import { toSortSelectionValue } from '~/search-domain/utils';

export function createQueryFactory(config: { searchRequest: SearchRequest; sorting: SearchRuntimeSortingConfig }) {
  const { searchRequest, sorting } = config;

  const indexName = searchRequest.indexName;
  const sortOptions = sorting.options;
  const defaultSort = sortOptions[0];
  if (!defaultSort) {
    throw new Error('Default sort not found');
  }

  const activeSort =
    sortOptions.find(sort => `${indexName}${toSortSelectionValue(sort)}` === searchRequest.request.indexName) ??
    defaultSort;

  const order = { [activeSort.field]: activeSort.order };
  const sortAggregate = { [activeSort.field]: { max: { field: activeSort.field } } };

  return merge(searchRequest, {
    body: {
      aggs: {
        subevents: {
          terms: {
            field: 'subeventId',
            order,
            size: 10000,
          },
          aggs: {
            ...sortAggregate,
            markets: {
              terms: {
                field: 'marketId',
                size: 10000,
              },
              aggs: {
                bets: {
                  terms: {
                    field: 'betId',
                    size: 10000,
                  },
                  aggs: {
                    best_odds: {
                      top_hits: {
                        size: 1,
                        sort: { oddsDecimal: 'desc' as const },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      size: 0,
    },
  });
}
